import { Typography, Modal, IconNode, Button } from '@components/base';
import { TextField, InputDatePicker, SelectLabel } from '@components/common';
import { useFormContext, Controller } from 'react-hook-form';
import Images from '@assets/images';
import { addBLDetails } from '@services/task.service';
import notify from '@helpers/toastify-helper';
import moment from 'moment';

import css from './index.module.scss';
import { useState } from 'react';
import { BL_TYPES } from '@helpers/constants';
import { getDiffBetweenTwoDates, getFormattedDate } from '@helpers/utils';

interface ExportClearanceDateModalProps {
  open: boolean;
  onClose: () => void;
  onFormSubmit: (data: any) => void;
}

const ExportClearanceDateModal = (props: any) => {
  const { open, onClose, onFormSubmit } = props;
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { isSubmitting }
  } = useFormContext();

  const toggleDatePicker = () => {
    setIsDatePickerOpen((prevState: boolean) => !prevState);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className={`${css.modalWrapper} ${isDatePickerOpen ? css.modalWrapperOpen : ''}`}>
        <section className={css.modalHeader}>
          <Typography variant="h4">Add Export Clearance date</Typography>
          <IconNode
            src={Images.crossBlack}
            alt="close icon"
            component="button"
            className={css.closeButton}
            onClick={onClose}
          />
        </section>

        <form noValidate className={css.formWrapper} onSubmit={handleSubmit(onFormSubmit)}>
          <section className={css.modalContent}>
            <Controller
              name="export_clearance_task_completed_date"
              control={control}
              render={({ field, fieldState }) => (
                <InputDatePicker
                  {...field}
                  required
                  setDatePickerOpen={setIsDatePickerOpen}
                  value={field.value}
                  placeholder="Select date"
                  label={`Export Clearance Date`}
                  onSelect={(day: Date | undefined) => {
                    field.onChange(day ?? null);
                    toggleDatePicker();
                  }}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  rootClassName={isDatePickerOpen ? css.fieldWrapperOpenModal : css.fieldWrapper}
                />
              )}
            />
          </section>
          <section className={css.modalFooter}>
            <Button variant="outlined-secondary" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              Save
            </Button>
          </section>
        </form>
      </div>
    </Modal>
  );
};

export default ExportClearanceDateModal;
